import { decimalLikeToDecimal } from '@snap-types/schemas/decimal';
import { z } from 'zod/v4';

import { calculationModeSchema } from './enums';

export const craftProductOptionsSubOptionSchema = z.object({
  name: z.string(),
  code: z.string().nullable(),
});

export type CraftProductOptionsSubOption = z.infer<
  typeof craftProductOptionsSubOptionSchema
>;

export const craftProductOptionsLotPriceSchema = z.object({
  qty: decimalLikeToDecimal,
  unitPrice: decimalLikeToDecimal,
});

export type CraftProductOptionsLotPrice = z.infer<
  typeof craftProductOptionsLotPriceSchema
>;

export const craftProductOptionsOptionSchema = z.object({
  name: z.string(),
  code: z.string().nullable(),
  price: decimalLikeToDecimal.nullable(),
  minimumLotCharge: decimalLikeToDecimal.nullable(),
  lotPrices: z.array(craftProductOptionsLotPriceSchema),
  calculationMode: calculationModeSchema,
  subOptionLabel: z.string().nullable(),
  unitsPerBatch: decimalLikeToDecimal.nullable(),
  subOptions: z.array(craftProductOptionsSubOptionSchema),
});

export type CraftProductOptionsOption = z.infer<
  typeof craftProductOptionsOptionSchema
>;

export const craftProductOptionsOptionGroupSchema = z.object({
  name: z.string(),
  options: z.array(craftProductOptionsOptionSchema).min(1),
});

export type CraftProductOptionsOptionGroup = z.infer<
  typeof craftProductOptionsOptionGroupSchema
>;

export const craftProductOptionsSchema = z.object({
  weight: decimalLikeToDecimal,
  optionGroups: z.array(craftProductOptionsOptionGroupSchema),
});

export type CraftProductOptions = z.infer<typeof craftProductOptionsSchema>;
